// หน้าเข้าสู่ระบบของแอป — ปลายทางที่ RequireSession พามาเมื่อยังไม่มี credential
//
// อยู่นอก layout ปกติ (ไม่มีแถบซ้าย) เพราะยังไม่รู้ว่าผู้ใช้เป็นใคร
// ?next= คือหน้าที่ผู้ใช้พยายามเข้า — login เสร็จแล้วพากลับไปที่นั่น
import { useEffect } from "react";
import { Navigate, useSearchParams } from "react-router";
import { useAppSelector } from "@/app/hooks";
import { Topbar } from "@features/navigation/components/topbar";
import { getSsoOutcome, ssoAutoTried, startSsoLogin } from "../lib/iam-sso";
import { StaffLogin } from "./staff-login";

export function LoginPage() {
  const [params] = useSearchParams();
  const session = useAppSelector((s) => s.session.current);
  const next = params.get("next") || "/";
  // ?expired=1 = ถูกเด้งมาเพราะ API ตอบ 401 ไม่ใช่เพิ่งเปิดแอป
  const expired = params.get("expired") === "1";

  /**
   * เข้าเงียบ ๆ ถ้า login ที่ระบบอื่นในเครือไว้แล้ว
   *
   * คนที่กดลิงก์มาจากระบบอื่น (เช่น job.fareastfamelineddb.com) ถือ cookie ของ IAM อยู่แล้ว
   * ส่งไป authorize แล้ว IAM เด้งกลับมาพร้อม token ทันทีโดยไม่ถามรหัส — ไม่ต้องเห็นหน้านี้เลย
   * ถ้ายังไม่เคย login ที่ไหน จะได้เห็นหน้ากรอกรหัสของ IAM แทนของเรา ซึ่งเข้าได้เหมือนกัน
   *
   * ลองได้ครั้งเดียวต่อแท็บ และไม่ลองเมื่อ:
   *   - กลับมาจาก IAM แบบไม่ผ่าน (จะวนไม่จบ)
   *   - เพิ่งกดออกจากระบบ (blockSsoAuto ตอน logout) — ไม่งั้นกดออกแล้วถูกพากลับเข้าทันที
   */
  useEffect(() => {
    if (session) return;
    if (getSsoOutcome().kind === "error") return;
    if (ssoAutoTried()) return;
    startSsoLogin(next);
  }, [session, next]);

  // มี session อยู่แล้วแต่มาโผล่หน้านี้ (กดลิงก์ /login ตรง ๆ หรือถูกเด้งมาก่อนที่
  // session จะถูกอ่านจาก localStorage) — พาไปต่อเลย ไม่ต้องให้กรอกซ้ำ
  if (session) return <Navigate to={next} replace />;

  return (
    <>
      <Topbar />
      <main className="page">
        <div className="login-page container">
          <StaffLogin
            next={next}
            standalone
            message={expired ? "เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่" : undefined}
          />
        </div>
      </main>
    </>
  );
}
